type TaskWithParent = { id?: number | null; parentId?: number | null };

export function getRootTasks<T extends TaskWithParent>(tasks: T[]): T[] {
  const ids = new Set(tasks.map((task) => task.id));
  return [
    ...tasks.filter((task) => !task.parentId),
    ...tasks.filter((task) => task.parentId && !ids.has(task.parentId)),
  ];
}

export function pageRootTasks<T>(
  tasks: T[],
  page: number,
  perPage: number
): T[] {
  if (perPage <= 0) return tasks;
  const start = (page - 1) * perPage;
  return tasks.slice(start, start + perPage);
}
